import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dining"}/>
}
